



function GridState(scope, manager) {
	
	var self = this;
	
	this.scope = scope
	this.manager = manager;
	this.data = manager.state[this.scope];
	this.getItem = function (name) {
		return self.data[name];
	}
	
	this.getItem = function(name, defaultvalue) {
		return self.data[name] || defaultvalue;
	}
	
	this.setItem = function(name, value) {
		// allow for multiple settings at once
		if (typeof name == "object") {
			for (var key in name) {
				self.data[key] = name[key];
			}
		} else {
			self.data[name] = value;
		}
		return self.save();
	}
	
	this.setDefault = function(name, value) {
		// allow for multiple settings at once
		if (typeof name == "object") {
			var data = {};
			for (var key in name) {
				// only set if no previous value
				if (typeof self.getItem(name) == "undefined") {
					data[key] = name[key];
				}
			}
			return self.setItem(data);
		} else {
			// only set if no previous value
			if (typeof self.getItem(name) == "undefined") {
				return self.setItem(name, value);
			}
		}
	}
	
	this.save = function() {
		return manager.save(self.scope, self.data);
		
	}
}

function GridVolatileStateManager() {

	var manager = this;
	this.state = {};
	this.fifo = [];
	
	this.save = function(scope, data) {
		this.state[scope] = data;
		this.moveFifo(self.scope);
	}
	
	this.moveFifo = function(scope) {
		if (this.fifo.length == 0 || this.fifo[this.fifo.length - 1] != scope) {
			for (var i=0; i<this.fifo.length; i++) {
				if (this.fifo[i] == scope) this.fifo.splice(i, 1);
			}
			this.fifo.push(scope);
			this.removeOld();
		}
	}
	
	this.removeOld = function() {
		if (this.fifo.length > 100) {
			var remove = this.fifo.splice(0,this.fifo.length - 100);
			for (var i=0; i<remove.length; i++) {
				delete this.state[remove[i]];
			}
		}
	}
	
	this.get = function (scope) {
		// returns a scoped storage
		this.state[scope] = this.state[scope] || {}
		return new GridState(scope, this);
	}

}

function GridPersistentStateManager(CurrentUserPrefs) {

	var manager = this;
	this.state = {};
	
	this.save = function(scope, data) {
		this.state[scope] = data;
		return CurrentUserPrefs.put(scope, data);
	}
	
	this.load = function (scope) {
		// returns a scoped storage
		scope = 'grid-prefs-' + scope;
		return CurrentUserPrefs.get(scope).then(function(prefs) {
			manager.state[scope] = prefs || {};
			return new GridState(scope, manager);
		});
		
	}

}


Grid = window.Grid || {};
Grid.GridVolatileStateManager = GridVolatileStateManager;
Grid.GridPersistentStateManager = GridPersistentStateManager;

